import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import { Button, Alert } from 'antd';
import PropTypes from 'prop-types';

import NavBar from '@sp/client/components/NavBar';

import Input from '../../components/form/Input';
import * as actions from '../Login/actions';

import s from './style.less';
import { required } from '../../components/form/validation';

class AdminSuperLogin extends React.Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    error: PropTypes.string,
    superLogin: PropTypes.func.isRequired,
  };

  submit = async values => {
    try {
      await this.props.superLogin(values);
    } catch (e) {
      throw new SubmissionError({
        _error: e.error,
      });
    }
  };

  render() {
    return (
      <NavBar>
        <div className={s.root}>
          <form onSubmit={this.props.handleSubmit(this.submit)}>
            <div className={s.form}>
              <div>
                <h3>
                  <i>Login as user</i>
                </h3>
                <Field
                  placeholder="E-mail address"
                  name="email"
                  component={Input}
                  type="email"
                  validate={required}
                />
                <Button htmlType="submit" type="primary">
                  Log In
                </Button>
                <br />
                <br />
                {this.props.error && (
                  <Alert message={this.props.error} type="error" />
                )}
              </div>
            </div>
          </form>
        </div>
      </NavBar>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  superLogin: values => dispatch(actions.superLogin(values)),
});

export default connect(
  null,
  mapDispatchToProps,
)(
  reduxForm({
    form: 'super-login',
  })(AdminSuperLogin),
);
